import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 mx-4 md:mx-10 mb-6 mt-20 rounded-3xl overflow-hidden">
      <div className="px-8 md:px-12 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10">
          <div className="lg:w-1/4">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-file-list-3-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading font-semibold text-lg text-background-50">itaobuy sheet</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed mb-4">
              Il punto di riferimento italiano per lo spreadsheet itaobuy. Scopri prodotti selezionati, foto QC e guide complete per i tuoi acquisti.
            </p>
            <div className="flex items-center gap-3">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-primary-400 hover:border-primary-500 transition-colors cursor-pointer">
                <i className="ri-global-line text-sm"></i>
              </a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-primary-400 hover:border-primary-500 transition-colors cursor-pointer">
                <i className="ri-shopping-bag-3-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-8">
            {[0, 4, 7, 10].map((start, idx) => (
              <div key={idx}>
                <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
                  {idx === 0 ? 'Categorie' : idx === 1 ? 'Abbigliamento' : idx === 2 ? 'Accessori' : 'Altro'}
                </h4>
                <ul className="space-y-2.5">
                  {categories.slice(start, idx === 0 ? 4 : idx === 1 ? 7 : idx === 2 ? 10 : 14).map((cat) => (
                    <li key={cat.id}>
                      <a
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-foreground-500 text-sm hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {cat.nameIt}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {currentYear} itaobuy sheet. Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-4">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors cursor-pointer">
              kaspreadsheet.com
            </a>
            <a href="/" className="text-foreground-500 text-xs hover:text-primary-400 transition-colors cursor-pointer">
              Home
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}